// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React context
import { useMaterialUIController, setMiniSidenav } from "context";

/**
 * Slim top bar shown only below the "xl" breakpoint (where the sidenav becomes an off-canvas
 * drawer). It gives touch users a visible, always-reachable button to open the navigation.
 */
function MobileTopBar({ title }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, darkMode } = controller;

  return (
    <MDBox
      component="header"
      display={{ xs: "flex", xl: "none" }}
      alignItems="center"
      px={1}
      sx={({ palette: { white, background, dark }, functions: { rgba } }) => ({
        position: "sticky",
        top: 0,
        zIndex: 1100,
        minHeight: "56px",
        paddingTop: "env(safe-area-inset-top)",
        backgroundColor: rgba(darkMode ? background.default : white.main, 0.92),
        backdropFilter: "saturate(200%) blur(20px)",
        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
        color: darkMode ? white.main : dark.main,
      })}
    >
      <IconButton
        aria-label="Open navigation menu"
        aria-expanded={!miniSidenav}
        aria-haspopup="dialog"
        onClick={() => setMiniSidenav(dispatch, false)}
        sx={{ color: "inherit", width: 48, height: 48 }}
      >
        <Icon fontSize="medium">menu</Icon>
      </IconButton>
      <MDTypography variant="h6" color="inherit" ml={1} noWrap>
        {title}
      </MDTypography>
    </MDBox>
  );
}

MobileTopBar.defaultProps = {
  title: "",
};

MobileTopBar.propTypes = {
  title: PropTypes.string,
};

export default MobileTopBar;
